const MAIL_DOMAIN = 'ieum.in';
const COMPANY_EMAIL_PATTERN = /^[a-z0-9][a-z0-9._-]{1,30}[a-z0-9]@ieum\.in$/;
const LOGIN_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const normalizeLoginEmail = (value) => String(value || '').trim().toLowerCase();

export const isValidLoginEmail = (value) => LOGIN_EMAIL_PATTERN.test(normalizeLoginEmail(value));

export const isValidCompanyEmail = (value) => COMPANY_EMAIL_PATTERN.test(normalizeLoginEmail(value));

export const deriveCompanyMailId = (value) => {
  const [rawLocal = ''] = normalizeLoginEmail(value).split('@');
  let mailId = rawLocal
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9._-]+/g, '-')
    .replace(/[._-]{2,}/g, '-')
    .replace(/^[^a-z0-9]+|[^a-z0-9]+$/g, '');

  if (!mailId) mailId = 'user';
  if (mailId.length < 3) mailId = `${mailId}-id`;
  mailId = mailId.slice(0, 32).replace(/[^a-z0-9]+$/g, '');
  if (mailId.length < 3) mailId = `${mailId}user`.slice(0, 3);
  return mailId;
};

export const deriveCompanyEmail = (value) => `${deriveCompanyMailId(value)}@${MAIL_DOMAIN}`;

export const companyMailIdOf = (value) => normalizeLoginEmail(value).replace(/@ieum\.in$/, '');

